import React, { FC } from "react";
import classNames from "classnames";

import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";

import { commonStyles } from "theme/common";

const useStyles = makeStyles((theme) => ({
  ...commonStyles(theme),
}));

type SeactionHeaderProps = {
  title: React.ReactNode;
};

const SeactionHeader: FC<SeactionHeaderProps> = ({ title }) => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="h2">{title}</Typography>
      <Box className={classNames(classes.mt1, classes.mb2)}>
        <Divider />
      </Box>
    </>
  );
};

export default SeactionHeader;
